import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import ConsultantLogin from './ConsultantLogin';
import CustomerStartQuote from './CustomerStartQuote';
import CustomerDetailsScreen from './CustomerDetailsScreen';
import CustomerCoverageScreen from './CustomerCoverageScreen';
import CustomerReviewSubmit from './CustomerReviewSubmit';
import CustomerThankYou from './CustomerThankYou';
import ConsultantDashboard from './ConsultantDashboard';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/quote/start" element={<CustomerStartQuote />} />
        <Route path="/quote/:applicationId/customer" element={<CustomerDetailsScreen />} />
        <Route path="/quote/:applicationId/coverage" element={<CustomerCoverageScreen />} />
        <Route path="/quote/:applicationId/review" element={<CustomerReviewSubmit />} />
        <Route path="/quote/thanks/:applicationId" element={<CustomerThankYou />} />

        <Route path="/consultant/login" element={<ConsultantLogin />} />
        <Route path="/consultant/dashboard" element={<ConsultantDashboard />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
